<div class="col-md-12 col-lg-12">
    <div class="mine_map_lite" id="mine_map_lite">
    </div>
</div>